/* istanbul ignore file */
export const OTHER_DROPDOWN_OPTION = {
	label: 'Others',
	value: ''
};

export const FIELD_NAMES = {
	ICB: 'icbIndicator',
	PARTY_NAME: 'billToPartyName',
	PARTY_CODE: 'billToParty',
	PARTNER_DETAILS: 'partyDetails',
};

export const SEARCH_STATUS = {
	PENDING: 'Pending',
	SUCCESS: 'Success',
	NO_DATA: 'No data found',
	FAILED: 'Failed',
	API_ERROR: 'API Error',
};

export enum PARTNER_TYPES {
	PARTNER = 'partner',
	CUSTOMER = 'customer',
	OTHER = 'other',
}